import { useEffect, useRef, useState } from 'react'

const THRESHOLD = 70   // ab hier wird ausgelöst
const MAX_PULL = 110   // maximale sichtbare Zugstrecke
const RESISTANCE = 0.5 // Finger-Weg → sichtbare Strecke

// Pull-to-Refresh: ganz oben weiter nach unten ziehen lädt den Feed neu.
export function usePullToRefresh(onRefresh) {
  const [pull, setPull] = useState(0)
  const [refreshing, setRefreshing] = useState(false)
  const state = useRef({ startY: null, active: false, refreshing: false, pull: 0 })
  const handler = useRef(onRefresh)
  handler.current = onRefresh

  useEffect(() => {
    const atTop = () => window.scrollY <= 0

    const onTouchStart = (e) => {
      if (state.current.refreshing || e.touches.length !== 1 || !atTop()) return
      state.current.startY = e.touches[0].clientY
      state.current.active = false
    }

    const onTouchMove = (e) => {
      const s = state.current
      if (s.startY === null || s.refreshing) return
      const delta = e.touches[0].clientY - s.startY
      if (delta <= 0 || !atTop()) {
        // nach oben gewischt oder weggescrollt → Geste verwerfen
        if (!s.active) s.startY = null
        return
      }
      s.active = true
      if (e.cancelable) e.preventDefault() // Browser-Bounce unterdrücken
      s.pull = Math.min(delta * RESISTANCE, MAX_PULL)
      setPull(s.pull)
    }

    const onTouchEnd = async () => {
      const s = state.current
      const wasActive = s.active
      s.startY = null
      s.active = false
      const triggered = wasActive && !s.refreshing && s.pull >= THRESHOLD
      if (!triggered) {
        s.pull = 0
        setPull(0)
        return
      }
      s.pull = THRESHOLD
      setPull(THRESHOLD)

      s.refreshing = true
      setRefreshing(true)
      try {
        await handler.current?.()
      } finally {
        s.refreshing = false
        s.pull = 0
        setRefreshing(false)
        setPull(0)
      }
    }

    window.addEventListener('touchstart', onTouchStart, { passive: true })
    window.addEventListener('touchmove', onTouchMove, { passive: false })
    window.addEventListener('touchend', onTouchEnd)
    window.addEventListener('touchcancel', onTouchEnd)
    return () => {
      window.removeEventListener('touchstart', onTouchStart)
      window.removeEventListener('touchmove', onTouchMove)
      window.removeEventListener('touchend', onTouchEnd)
      window.removeEventListener('touchcancel', onTouchEnd)
    }
  }, [])

  return { pull, refreshing, ready: pull >= THRESHOLD, threshold: THRESHOLD }
}
